import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c01ffdb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overlay-inner"
}

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileBackground',
  props: {
    profileBackground: { default: '' },
    height: { default: 0 },
    width: { default: 0 },
    blur: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const profileBackgroundUrl = computed(() => props.profileBackground)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["profile-background", { blur: _ctx.blur }]),
    style: _normalizeStyle({
      backgroundImage: profileBackgroundUrl.value
        ? `url(${profileBackgroundUrl.value})`
        : 'none',
      width: _ctx.width ? `${_ctx.width}px` : '100%',
      height: _ctx.height ? `${_ctx.height}px` : '100%',
    }),
    "data-testid": "profile-background"
  }, [
    (_ctx.profileBackground)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default")
  ], 6 /* CLASS, STYLE */))
}
}

})